<template>
        <div class="container p-3 pt-5 my-4 border in-border-header">
            <div class="section-header">
                {{ $t('pos.device_details') }}
            </div>
            <form id="device_details">
                <kt-row>
                    <kt-col lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="pos_type">
                                {{ $t('pos.pos_type') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <select
                                    id="pos_type"
                                    name="pos_type"
                                    v-model="form_data.device_info.pos_type"
                                    class="form-control  kt-selectpicker-device"
                            >
                                <option
                                        :value="deviceTypeList.GPRS">
                                    {{ deviceTypeList.GPRS }}
                                </option>
                                <option
                                        :value="deviceTypeList.LAN">
                                    {{ deviceTypeList.LAN }}
                                </option>
                                <option v-if="psp=='PASARGAD'"
                                        :value="deviceTypeList.Dialup">
                                    {{ deviceTypeList.Dialup }}
                                </option>
                                <option
                                        :value="deviceTypeList.WIFI">
                                    {{ deviceTypeList.WIFI }}
                                </option>
                                <option v-if="psp=='NOVIN'"
                                        :value="deviceTypeList.AndroidPos">
                                    {{ deviceTypeList.AndroidPos }}
                                </option>
                                <option v-if="psp=='NOVIN'"
                                        :value="deviceTypeList.WIRELESS_POS">
                                    {{ deviceTypeList.WIRELESS_POS }}
                                </option>
                                <option v-if="psp=='NOVIN'"
                                        :value="deviceTypeList.HDLC">
                                    {{ deviceTypeList.HDLC }}
                                </option>

                                <option v-if="psp=='NOVIN'"
                                        :value="deviceTypeList.MPOS">
                                    {{ deviceTypeList.MPOS }}
                                </option>
                                <option v-if="psp=='NOVIN'"
                                        :value="deviceTypeList.WIFI_GPRS">
                                    {{ deviceTypeList.WIFI_GPRS }}
                                </option>
                            </select>
                            <div class="my-4">
                            </div>
                        </kt-form-group>
                    </kt-col>
<!--                    <kt-col lg="4" md="6" xs="12">-->
<!--                        <kt-form-group>-->
<!--                            <kt-form-label for="pos_model">-->
<!--                                {{ $t('pos.pos_model') }}<span style="color: red">{{ ' *' }}</span>-->
<!--                            </kt-form-label>-->
<!--                            <select-->
<!--                                    id="pos_model"-->
<!--                                    name="pos_model"-->
<!--                                    v-model="form_data.device_info.pos_model"-->
<!--                                    class="form-control kt-selectpicker-device-search"-->
<!--                            >-->
<!--                                <option-->
<!--                                        v-for="item in constants.pos_model"-->
<!--                                        v-bind:key="item"-->
<!--                                        :value="item">-->
<!--                                    {{ item }}-->
<!--                                </option>-->
<!--                            </select>-->
<!--                            <div class="my-4">-->
<!--                            </div>-->
<!--                        </kt-form-group>-->
<!--                    </kt-col>-->
<!--                    <kt-col lg="4" md="6" xs="12">-->
<!--                        <kt-form-group>-->
<!--                            <kt-form-label for="terminal_type">-->
<!--                                {{ $t('pos.terminal_type') }}<span style="color: red">{{ ' *' }}</span>-->
<!--                            </kt-form-label>-->
<!--                            <select-->
<!--                                    id="terminal_type"-->
<!--                                    name="terminal_type"-->
<!--                                    v-model="form_data.device_info.terminal_type"-->
<!--                                    class="form-control kt-selectpicker-device"-->
<!--                            >-->
<!--                                <option-->
<!--                                        :value="terminalTypeList.POS">-->
<!--                                    {{ terminalTypeStr.POS }}-->
<!--                                </option>-->
<!--                                <option-->
<!--                                        :value="terminalTypeList.WIRELESS_POS">-->
<!--                                    {{ terminalTypeStr.WIRELESS_POS }}-->
<!--                                </option>-->
<!--                            </select>-->
<!--                            <div class="my-4">-->
<!--                            </div>-->
<!--                        </kt-form-group>-->
<!--                    </kt-col>-->
<!--                    <kt-col lg="4" md="6" xs="12">-->
<!--                        <kt-form-group>-->
<!--                            <kt-form-label for="serial_number">-->
<!--                                {{ $t('pos.serial_number') }}<span style="color: red">{{ ' *' }}</span>-->
<!--                                <div v-if="form_data.device_info.status == deviceStatus.ALLOCATED"-->
<!--                                     class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">-->
<!--                                    <span class="tooltip-text">{{ $t('pos.serial_is_allocated') }}</span>-->
<!--                                    <i class="fa fa-check" style="margin-right:7px; font-size: 14px;color: #1dc9b7"></i>-->
<!--                                </div>-->
<!--                            </kt-form-label>-->
<!--                            <kt-form-control-->
<!--                                    dir="ltr"-->
<!--                                    id="serial_number"-->
<!--                                    name="serial_number"-->
<!--                                    v-model="form_data.device_info.serial_number"-->
<!--                                    class="form-control"-->
<!--                            ></kt-form-control>-->
<!--                        </kt-form-group>-->
<!--                    </kt-col>-->
                    <kt-col v-show="form_data.device_info.pos_type === 'MPOS'" lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="mobile_gprs">
                                {{ $t('pos.mobile_gprs') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    dir="ltr"
                                    id="mobile_gprs"
                                    name="mobile_gprs"
                                    v-model="form_data.device_info.mobile_gprs"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
            </form>
<!--            <kt-row>-->
<!--                <kt-col v-if="form_data.device_info.status == deviceStatus.ALLOCATED" lg="12" md="12" xs="12">-->
<!--                    <kt-form-action>-->
<!--                        <kt-button-->
<!--                                class="m-2"-->
<!--                                size="md"-->
<!--                                @click="replaceSerialNumber"-->
<!--                                variant="success"-->
<!--                                type="submit"-->
<!--                                v-bind:wide="true"-->
<!--                                id="replace_serial"-->
<!--                        >-->
<!--                            {{ $t('pos.replace_serial') }}-->
<!--                        </kt-button>-->
<!--                    </kt-form-action>-->
<!--                </kt-col>-->
<!--                <kt-col v-if="wizard.operation=='watch' && form_data.device_info.status == deviceStatus.PENDING" lg="12" md="12" xs="12">-->
<!--                    <kt-form-action>-->
<!--                        <kt-button-->
<!--                                class="m-2"-->
<!--                                size="md"-->
<!--                                @click="replaceSerialNumber"-->
<!--                                variant="success"-->
<!--                                type="submit"-->
<!--                                v-bind:wide="true"-->
<!--                                id="replace_serial"-->
<!--                        >-->
<!--                            {{ $t('pos.register_serial') }}-->
<!--                        </kt-button>-->
<!--                    </kt-form-action>-->
<!--                </kt-col>-->
<!--            </kt-row>-->
<!--        </div>-->
        <kt-row>
            <kt-col lg="4" md="4" xs="4">
                <kt-form-action style=" direction: ltr; display: inline;">
                    <kt-button
                            class="m-2"
                            size="md"
                            @click="step_back"
                            variant="danger"
                            type="submit"
                            v-bind:wide="true"
                            id="step_back"
                    >
                        {{ $t('label.step_back') }}
                    </kt-button>
                </kt-form-action>
            </kt-col>
            <kt-col lg="6" md="6" xs="4"></kt-col>
            <kt-col lg="2" md="2" xs="4">
                <kt-form-action style=" display: inline;">
                    <kt-button
                            class="m-2"
                            size="md"
                            @click="next_step"
                            variant="success"
                            type="submit"
                            v-bind:wide="true"
                            id="next_step"
                    >
                        {{ $t('label.next_step') }}
                    </kt-button>
                </kt-form-action>
            </kt-col>
        </kt-row>
    </div>

</template>

<script>
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import Inputmask from "inputmask";
import toastr from "toastr";
import {mapGetters} from "vuex";
import {KTApp} from '@/plugins/core/app';
import {terminalTypeList, terminalTypeStr} from '@/constants/terminalType'
import {deviceStatus} from '@/constants/PosStatus'
import {deviceTypeList, deviceTypeStr} from '@/constants/posDeviceType'
import {posService} from '@/common/api.service'


export default {
    data() {
        return {
            p: true,
            terminalTypeList,
            deviceStatus,
            terminalTypeStr,
            deviceTypeList,
            deviceTypeStr,
        }
    },
    props: {
        wizard: {
            type :Object
        } ,
        form_data: {
            type :Object
        } ,
    },
    methods: {
        next_step() {
            let form = $('#device_details')
            let btn = $('#next_step')
            form.validate({
                lang: 'fa',
                rules: {
                    pos_type: {
                        required: true,
                    },
                    // pos_model: {
                    //     required: true
                    // },
                    // serial_number: {
                    //     required: true
                    // },

                    mobile_gprs: {
                        required: () => {
                            if (this.form_data.device_info.pos_model === 'Mpos') return true; else return false
                        },
                    },
                }
            });
            if (!form.valid()) {
                return
            }
            this.wizard.current_step++;
        },
        step_back() {
            this.wizard.current_step--;
        },
        afterDispatch() {
            setTimeout(() => {
                $('.kt-selectpicker-device').selectpicker({
                    size: 6,
                    liveSearch: false,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_chose')
                });

            }, 500);
            setTimeout(() => {
                $('.kt-selectpicker-device-search').selectpicker({
                    size: 6,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_chose')
                });

            }, 500);
        },
        replaceSerialNumber() {
            let form = $('#device_details')
            let btn = $('#replace_serial')
            form.validate({
                lang: 'fa',
                rules: {
                    port_type: {
                        required: true
                    },
                    terminal_type: {
                        required: true
                    },

                    pos_type: {
                        required: true,
                    },
                    pos_model: {
                        required: true
                    },
                    serial_number: {
                        required: true
                    },
                }
            });
            if (!form.valid()) {
                return
            }
            KTApp.progress(btn)
            let params = {
                psp: this.psp,
                port_type: this.form_data.device_info.port_type,
                terminal_type: this.form_data.device_info.terminal_type,
                pos_type: this.form_data.device_info.pos_type,
                pos_model: this.form_data.device_info.pos_model,
                serial_number: this.form_data.device_info.serial_number,
                pos_device_id: this.form_data.device_info.id,
            }
            posService.replaceSerialNumber(params).then(response => {
                if (this.form_data.device_info.status == deviceStatus.ALLOCATED){
                this.form_data.device_info.status = deviceStatus.REPLACING
                }
                return this.toastr.success(response.data.message)
            }).catch(({response}) => {
                return this.toastr.error(response.data.message)
            });

            KTApp.unprogress(btn)
        }
    },
    mounted() {
        this.afterDispatch()
        setTimeout(() => {
            document.getElementById('mobile_gprs') && Inputmask('09999999999')
                    .mask(document.getElementById('mobile_gprs'))
        }, 500)
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
        ...mapGetters('pos', [
            'constants', 'psp'
        ])
    },
}
</script>
<style>
.kt-form-label {
    text-align: right !important;
}
</style>